<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl ">Neues Formular</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Titel</span>
                <input class="border p-2 rounded w-3/4"  v-model="name" :class="{'border p-2 rounded w-3/4 border-red-500' : showError && !name}" data-ui="formular-title">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Magazine Typ</span>

                <select class="border p-2 rounded w-3/4" v-model="type" :class="{'border p-2 rounded w-3/4 border-red-500' : showError && !type}" data-ui="magazine-type">
                  <option :value="0">kein type</option>
                  <option v-for="magazineType in magazineTypes" :key="magazineType.magazineTypeId" :value="magazineType.magazineTypeId">
                    {{ magazineType.magazineTypeTitle}}
                  </option>
                </select>
              </div>
              <button class=" mr-1 w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" @click="createFormular" data-ui="create-new-formular-button">
                Erstellen</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Sidebar />

  </div>
</template>

<script >
import Sidebar from "@/components/Administration/Sidebar.vue";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import router from "@/router";
import {shouldWriteResult} from "@apollo/client/core/QueryInfo";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, Sidebar},
  data(){
    return{
      name: "",
      type: null,
      magazineTypes: [],
      showError: false,
      accordionIndex: 0,
    }
  },
  methods:{
    goBack(){
      router.push("/administration")
    },
    async getMagazineTypes() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getMagazineTypes {
              getMagazineTypes {
                magazineTypeId
                magazineType
                magazineTypeTitle
              }
            }
          `
        });

        this.magazineTypes = response.data.getMagazineTypes;

      } catch (error) {
        console.error("Fehler beim Abrufen der magazineTypes:", error);
      }
    },
    async createFormular(){

      if (!this.name || !this.magazineTypes) {
        this.showError = true;
        return;
      }
      this.showError = false;

      const formularData = {
        formularName: this.name,
        magazineTypeID: this.type,
      };

      const mutation = gql`
        mutation createFormular($formular: FormularInput!) {
          createFormular(formular: $formular) {
            success
          }
        }
      `;
      try {
        const variables = {
          formular: formularData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.createFormular.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Formular erstellt",
            message: "Das Formular wurde erstellt",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.getMagazineTypes()
  },
  watch: {
    // get accordionIndex from url
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>